const fingerPrintPrompt = async () => {
  try {
    const publicKey = {
      challenge: new Uint8Array([21, 31, 105]),
      authenticatorSelection: {
        authenticatorAttachment: "platform",
        userVerification: "required",
      },
      rp: {
        name: "iLenkrad",
      },
      user: {
        id: new Uint8Array(16),
        name: "iLenkradUser",
        displayName: "iLenkradUser",
      },
      pubKeyCredParams: [
        {
          type: "public-key",
          alg: -7,
        },
      ],
    };

    const newCredentialInfo = await navigator.credentials.create({ publicKey });

    const response = newCredentialInfo.response;
    console.log(response, "res");
    const clientExtensionsResults =
      newCredentialInfo.getClientExtensionResults();
    console.log(clientExtensionsResults, "clRes");

    navigator.credentials.preventSilentAccess();
    return true;
  } catch (err) {
    console.error(err, "err");
    return false;
  }
};

export default fingerPrintPrompt;
